<template>
  <div ref="rootRef" style="position: relative">
    <button type="button" class="select-trigger" @click="isOpen = !isOpen">
      <span>{{ selectedLabel }}</span>
      <span class="select-arrow" :class="{ open: isOpen }">▾</span>
    </button>

    <div v-if="isOpen" class="select-dropdown">
      <button
        v-for="opt in options"
        :key="opt.value"
        type="button"
        class="select-option"
        :class="{ active: opt.value === modelValue }"
        @click="select(opt.value)"
      >
        {{ opt.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';

const props = defineProps<{
  modelValue: string;
  options: { value: string; label: string }[];
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const rootRef = ref<HTMLElement | null>(null);
const isOpen = ref(false);

onClickOutside(rootRef, () => {
  isOpen.value = false;
});

const selectedLabel = computed(
  () =>
    props.options.find((o) => o.value === props.modelValue)?.label ??
    props.options[0]?.label ??
    '',
);

function select(value: string) {
  emit('update:modelValue', value);
  isOpen.value = false;
}
</script>
